import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import logPrivacySettingsPageViewed from '@alltrails/analytics/events/logPrivacySettingsPageViewed';
import CustomProvider from 'components/CustomProvider';
import * as styles from './styles/styles.module.scss';
import { getPrivacyPolicy, updatePrivacyPolicy } from '../../../utils/requests/privacy_policy_requests';
import GeneralPrivacyPolicyModal from '../modals/GeneralPrivacyPolicyModal';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import PrivacyIcon from '../../../../assets/images/shared/privacyLock.svg';
import { logPrivacyPolicyAmplitudeEvents } from '../../../utils/privacy_policy_amplitude_helpers';
import { contextPropTypes } from '../../../proptypes/shared';

const {
  strings: {
    ICON,
    PRIVACY_POLICY: { PRIVACY_SETTINGS }
  }
} = StringConstantsMixin;

const DEFAULT_PRIVACY_POLICY = { id: null, policy: null };

const GeneralPrivacyPolicy = ({ context }) => {
  const userId = context.currentUser?.id;
  const [showModal, setShowModal] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(DEFAULT_PRIVACY_POLICY);
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setPrivacyPolicy(DEFAULT_PRIVACY_POLICY);
  };

  const handlePrivacyPolicyClick = () => {
    setShowModal(true);
    logPrivacySettingsPageViewed();
    getPrivacyPolicy(userId)
      .then(privatePolicy => {
        const { id, policy } = privatePolicy;
        setPrivacyPolicy({ id, policy });
      })
      .catch(err => {
        console.error('handlePrivacyPolicyClick, <GeneralPrivacyPolicy />', err);
        closeModal();
      });
  };

  const handleSave = (policy, applyBulk) => {
    setLoading(true);
    updatePrivacyPolicy(userId, policy, applyBulk)
      .then(() => {
        closeModal();
      })
      .catch(err => {
        console.error('handleSave, <GeneralPrivacyPolicy /> ', err);
      });
    logPrivacyPolicyAmplitudeEvents(privacyPolicy?.policy, policy);
    setLoading(false);
  };

  return (
    <CustomProvider>
      {showModal &&
        createPortal(
          <GeneralPrivacyPolicyModal
            initialPrivacyPolicy={privacyPolicy?.policy}
            closeModal={closeModal}
            loading={loading}
            handleSave={handleSave}
            context={context}
          />,
          document.getElementById('modalPortal')
        )}
      <li className={styles.container}>
        <img src={PrivacyIcon} alt={ICON} />
        <button type="button" onClick={handlePrivacyPolicyClick}>
          <span>{PRIVACY_SETTINGS}</span>
        </button>
      </li>
    </CustomProvider>
  );
};

GeneralPrivacyPolicy.propTypes = {
  context: contextPropTypes.isRequired
};

export default GeneralPrivacyPolicy;
